import { Box, Grid, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";

import FieldsDocsTable from "../contributions/ContributionsDocsTable";
import ContributionsTable from "../contributions/ContributionsTable";
import SEEmployeePayrollsTable from "../employees_se/SEEmployeePayrollsTable";
import translate from "../i18n/Translator";
import { SpecializedServicesEmployee } from "../model/CfdiSe";
import { Contract } from "../model/Contract";
import { Contribution } from "../model/Contribution";

interface ContractIssuedDocsProps {
    contract: Contract;
    uploadSipare: boolean;
}

export default function ContractDocs(props: ContractIssuedDocsProps) {
    const [contributions, setContributions] = useState<Contribution[]>();

    useEffect(() => {
        setContributions(props.contract.specialized_services?.contributions || []);
    }, [props.contract]);

    const onUpdatedContributions = (contributions: Contribution[]) => {
        setContributions(contributions);
    };

    return (
        <Box pt={2} px={2}>
            <Grid container alignItems="flex-start" justifyContent="space-between" spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="subtitle2" color="primary" paragraph>
                        <strong>{translate("se_contracts.view.docs.employees")}</strong>
                    </Typography>
                    <Box mx={-2} mb={2}>
                        <SEEmployeePayrollsTable
                            employees={
                                props.contract.specialized_services?.employees?.filter((seEmployee) =>
                                    Boolean(seEmployee.employee)
                                ) || ([] as SpecializedServicesEmployee[])
                            }
                        />
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="subtitle2" color="primary" paragraph>
                        <strong>{translate("contributions.title")}</strong>
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Box mx={-2}>
                                <ContributionsTable
                                    uploadSipare={props.uploadSipare}
                                    contributions={contributions || []}
                                    onUpdated={onUpdatedContributions}
                                    status="loaded"
                                    avoidGrouping
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
                {props.contract.specialized_services &&
                    props.contract.specialized_services.fields &&
                    props.contract.specialized_services.fields.length > 0 && (
                        <Grid item xs={12}>
                            <Typography variant="subtitle2" color="primary" paragraph>
                                <strong>{translate("contributions.docs.docs_exp")}</strong>
                            </Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Box mx={-2}>
                                        <FieldsDocsTable
                                            fields={
                                                props.contract.specialized_services
                                                    ? props.contract.specialized_services.fields
                                                    : []
                                            }
                                            tenantId={props.contract.tenant_id}
                                            providerId={props.contract.provider_id || ""}
                                        />
                                    </Box>
                                </Grid>
                            </Grid>
                        </Grid>
                    )}
            </Grid>
        </Box>
    );
}
